export const COPILOT_ACTION_TYPES = {
  OPEN_CONTENT: 'OPEN_CONTENT',
} as const;

export type CopilotActionType =
  (typeof COPILOT_ACTION_TYPES)[keyof typeof COPILOT_ACTION_TYPES];

export const COPILOT_DOMAINS = {
  DSR: 'DSR',
} as const;

export const COPILOT_FEATURES = {
  BUYER_COPILOT: 'buyer_copilot',
} as const;

export const PAYLOAD_TYPES = {
  TEXT: 'TEXT',
  CUSTOM_COMPONENT: 'CUSTOM_COMPONENT',
} as const;

export const CUSTOM_TYPE_NAME = {
  BUYER_COPILOT_ANSWER_NOT_FOUND: 'buyer_copilot_answer_not_found',
} as const;

export const EVENT_NAMES = {
  CHAT_QUERY_SENT: 'chat_query_sent',
  AI_CHAT_REPLY_COPIED: 'ai_chat_reply_copied',
  AI_CHAT_REPLY_FEEDBACK_SUBMITTED: 'ai_chat_reply_feedback_submitted',
  ANSWER_MENTIONS_CLICKED: 'answer_mentions_clicked',
  CHAT_DELETED: 'chat_deleted',
  CHAT_RESULTS_DISPLAYED_SUCCESSFULLY: 'chat_results_displayed_successfully',
  AI_CHAT_PANEL_OPENED: 'ai_chat_panel_opened',
  ANSWER_GENERATED: 'ai_chat_reply_generated',
} as const;

export const REGION_HEADER_NAME = 'tenant_residency' as const;
